export default __webpack_public_path__ + "static/media/demo3.94fddc3e.png";